<template>
  <div class="success_case_wrap">
    <Banner />
  </div>
</template>
<script>
import Banner from '@/views/successcase/components/Banner.vue'

export default {
  name: 'SuccessCase',
  components: { Banner },
  data() {
    return {
    }
  },
  computed: {}
}
</script>

<style scoped>
* {
  margin: 0;
}
.success_case_wrap {
  margin-bottom: 50px;
}

</style>



// WEBPACK FOOTER //
// src/views/successcase/index.vue